import PropertyGroup from '../utils/PropertyGroup';

export default {
  create(data, id, session) {
    return new PropertyGroup(data);
  }
};
